// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateCustomContribution = (property, value) => ({
    property,
    type: actions.UPDATE_TABM_SPA_CLAIM_CONTRIBUTION,
    value: parseFloat(value)
});



// WEBPACK FOOTER //
// ./src/tabm/spa-details/action-creators/custom-contributions.js